export default {
  ["canUndo"](state) {
    return !!state.undo.length;
  },
  ["canRedo"](state) {
    return !!state.redo.length;
  }
};
